module.exports = __webpack_public_path__ + "media/Audio17_k.7a3a4226.wav";